<template>
	<div class="modal fade" id="settlementModal" tabindex="-1" aria-labelledby="settlementLabel" aria-hidden="true">
		<div class="modal-dialog">
			<div class="modal-content rounded-0">
				<div class="modal-header">
					<h5 class="modal-title" id="settlementLabel">Settlement Log ID ({{ settlementLogId }})</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
          </button>
				</div>
				<div class="modal-body rounded-none">
					<div class="accordion" id="paymentItemAccordion">
						<div class="card mb-2" v-for="item in settlementItems" :key="item.id">
							<div class="card-header bg--primary text-white p-0" id="headingOne">
								<h2
									:data-target='`#collapse${item.id}`'
									class="mb-0 text-left pointer fs-20 w-100 p-3"
									style="cursor: pointer;"
									data-toggle="collapse"
									ref="customControlAccordion"
									aria-expanded="true"
									:aria-controls="`collapse${item.id}`"
								>
									{{ item.transaction_ref_no }}
								</h2>
							</div>

							<div
                :id="`collapse${item.id}`"
								class="collapse"
								aria-labelledby="headingOne"
								data-parent="#paymentItemAccordion"
							>
								<ul class="list-group list-group-flush">
									<li class="list-group-item d-flex justify-content-between">
                    <div class="text-muted">Bill Refrence</div>
                    <div>{{ item.bill_ref }}</div>
									</li>
									<li class="list-group-item d-flex justify-content-between">
                    <div class="text-muted">Settlement amount</div>
                    <div>{{ new Intl.NumberFormat('en-GB').format(item.settlement_amount) }}</div>
									</li>
									<li class="list-group-item d-flex justify-content-between">
                    <div class="text-muted">Settlement Date</div>
                    <div>{{ item.settlement_date }}</div>
									</li>
									<li class="list-group-item d-flex justify-content-between">
                    <div class="text-muted">Tax amount</div>
                    <div>{{ new Intl.NumberFormat('en-GB').format(item.tax_amount) }}</div>
									</li>
									<li class="list-group-item d-flex justify-content-between">
                    <div class="text-muted">Tax payer name</div>
                    <div>{{ item.tax_payer_name }}</div>
									</li>
									<li class="list-group-item d-flex justify-content-between">
                    <div class="text-muted">Tbpkid</div>
                    <div>{{ item.tbpkid }}</div>
									</li>
									<li class="list-group-item d-flex justify-content-between">
                    <div class="text-muted">Revenue stream ID</div>
                    <div>{{ item.revenue_stream_id }}</div>
									</li>
									<li class="list-group-item d-flex justify-content-between">
                    <div class="text-muted">Revenue sub stream ID</div>
                    <div>{{ item.revenue_sub_stream_id }}</div>
									</li>
									<li class="list-group-item d-flex justify-content-between flex-column">
                    <div class="text-muted mb-2">Settlement Notes</div>
                    <div>{{ item.settlement_notes }}</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		settlementItems : {
			type: Array,
			default: () => [],
			required: false
		},
		settlementLogId: {
			type: Number,
			default: () => null,
			required: false
		}
	},
	methods: {
		toggleFirstAccordion() {
			const accordions = this.$refs.customControlAccordion
			accordions[0].click()
		}
	},
	updated() {
		this.$nextTick(function () {
			this.toggleFirstAccordion()
		})
	}
}
</script>